import { config } from "../../config"
import { LoginResult, MinimalUser } from "./data-types"

export const loginEmail = async (email: string, password: string, language: string): Promise<LoginResult> => {
    try {
        const res = await fetch(`${config.api.urlV1}/login/`, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                email,
                password,
                strategy: "email",
                language,
            })
        })

        if (res.status !== 200) {
            const body = await res.json()

            return {
                error: body.Error || body.Warning
            }
        }

        const body: MinimalUser & { token: string } = await res.json()

        return {
            userToken: {
                user: body,
                token: {
                    access: body.token,
                    refresh: "",
                }
            }
        }
    } catch (e) {
        return {
            error: e as string
        }
    }
}

export const loginFacebook = async (access_token: string, language: string): Promise<LoginResult> => {
    try {
        const res = await fetch(`${config.api.urlV1}/login/`, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                access_token,
                language,
                strategy: 'facebook',
            })
        })

        if (res.status !== 200) {
            const body = await res.json()

            return {
                error: body.Error || body.Warning
            }
        }

        const body: MinimalUser & { token: string } = await res.json()

        return {
            userToken: {
                user: body,
                token: {
                    access: body.token,
                    refresh: "",
                }
            }
        }
    } catch (e) {
        return {
            error: e as string
        }
    }
}

export const loginApple = async (access_token: string, language: string): Promise<LoginResult> => {
    try {
        console.log({ apple: 'apple', access_token })
        const res = await fetch(`${config.api.urlV1}/login/apple`, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({
                access_token,
                language,
                strategy: 'apple',
            })
        })

        if (res.status !== 200) {
            const body = await res.json()

            return {
                error: body.Error || body.Warning
            }
        }

        const body: MinimalUser & { token: string } = await res.json()

        return {
            userToken: {
                user: body,
                token: {
                    access: body.token,
                    refresh: "",
                }
            }
        }
    } catch (e) {
        return {
            error: e as string
        }
    }
}